// extracted by mini-css-extract-plugin
export var backgroundImage = "FormWithImageRight-module--backgroundImage--60d97";
export var btn = "FormWithImageRight-module--btn--aa1d0";
export var content = "FormWithImageRight-module--content--fcee2";
export var form = "FormWithImageRight-module--form--0d0a7";
export var formSubmit = "FormWithImageRight-module--formSubmit--d0eb6";
export var formSubmitWrapper = "FormWithImageRight-module--formSubmitWrapper--b930e";
export var personalInfo = "FormWithImageRight-module--personalInfo--38610";
export var submitBtn = "FormWithImageRight-module--submitBtn--c8f22";
export var submitSection = "FormWithImageRight-module--submitSection--b1b45";
export var validation = "FormWithImageRight-module--validation--da0c3";
export var wrapper = "FormWithImageRight-module--wrapper--2c029";